/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import Vue from 'vue';
import axios from 'axios'
import qs from 'qs'
import router from '../router'
import store from '../store/index'
import jwt from '../plugins/jwt.js'
import { base, userApiUrl } from '../api/base.js' // 导入接口域名列表
import { Notify } from 'vant'
import {
  LOGOUT,
  CHANGE_NETWORK,
  SET_TOKEN
} from '../store/mutation-types'

Vue.use(Notify)

window.isReresh = false
let requests = []

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  Notify({
    message: msg,
    duration: 5000,
    type: 'danger'
  })
}

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  tip('登录过期，请重新登录!')
  store.commit('user/' + LOGOUT, null)
  setTimeout(() => {
    router.replace({
      name: 'Login',
      query: {
        redirect: router.currentRoute.fullPath
      }
    })
  }, 1000)
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin()
      break
      // 403 token过期
    case 403:
      toLogin()
      break
      // 404请求不存在
    case 404:
      tip('请求的资源不存在!')
      break
    default:
      tip('请求的服务暂时不可用，请稍后重试!')
  }
}

// 创建axios实例
var instance = axios.create({
  timeout: 1000 * 12
})
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
instance.defaults.withCredentials = true

const refreshToken = () => {
  const baseURL = process.env.NODE_ENV !== 'production' ? base.development : base.production
  const token = store.getters['user/token']
  return instance.get(baseURL + userApiUrl.REFRESH_TOKEN_URL, {
    headers: {
      Authorization: token
    }
  })
    .then(res => res.data)
}
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    if (config.method === 'post' && config.headers['Content-Type'] !== 'multipart/form-data') {
      config.data = qs.stringify({
        ...config.data,
        _t: Date.parse(new Date()) / 1000
      })
    } else if (config.method === 'get') {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      }
    }
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    const token = store.getters['user/token']
    if (token) {
      if (jwt.verify(token) || config.url.indexOf(userApiUrl.REFRESH_TOKEN_URL) >= 0) {
        config.headers.Authorization = token
        return config
      } else {
        if (!window.isReresh) {
          window.isReresh = true
          refreshToken().then(res => {
            window.isReresh = false
            if (res.code !== 200) {
              throw new Error(res.message)
            } else {
              store.commit('user/' + SET_TOKEN, res.data.token)
              return res.data.token
            }
          }).then((newtoken) => {
            requests.forEach(cb => cb(newtoken))
            requests = []
          }).catch(res => {
            toLogin()
            return config
          })
        }
        const retryOriginalRequest = new Promise((resolve) => {
          requests.push((newtoken) => {
            config.headers.Authorization = newtoken
            resolve(config)
          })
        })
        return retryOriginalRequest
      }
    } else {
      return config
    }
  },
  error => Promise.error(error)
)

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => {
    store.commit('global/' + CHANGE_NETWORK, true)
    return res.status === 200 ? Promise.resolve(res) : Promise.reject(res)
  },
  // 请求失败
  error => {
    const {
      response
    } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      store.commit('global/' + CHANGE_NETWORK, true)
      errorHandle(response.status, response.data.message)
      return Promise.reject(response)
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      store.commit('global/' + CHANGE_NETWORK, false)
    }
  }
)

export default instance
